<template>
    <div class="availability">
        <div class="availability__title justify-content-end">
            <a
                :href="`/client/artist/${artistId}/book`"
                class="btn btn_golden"
            >
                <span>Book Now</span>
            </a>
        </div>
        <div class="availability__filter">
            <select class="custom-select" v-model="year">
                <option
                    v-for="y in [2025, 2024, 2023]"
                    :key="y"
                    :value="y">{{ y }}
                </option>
            </select>
            <div class="availability__sort">
                <span class="ttl">legend:</span>
                <a href="javascript:void(0)" class="sort sort_available">Available</a>
                <a href="javascript:void(0)" class="sort sort_hold">Hold</a>
                <a href="javascript:void(0)" class="sort sort_booked">Booked</a>
                <a href="javascript:void(0)" class="sort sort_blackout">Blackout Day</a>
                <a href="javascript:void(0)" class="sort sort_travel">Travel Day</a>
            </div>
        </div>
        <div class="calendar__row">
            <div class="calendar__month"></div>
            <div class="calendar__week">Sun</div>
            <div class="calendar__week">Mon</div>
            <div class="calendar__week">Tue</div>
            <div class="calendar__week">Wen</div>
            <div class="calendar__week">Thu</div>
            <div class="calendar__week">Fri</div>
            <div class="calendar__week">Sat</div>
            <div class="calendar__week">Sun</div>
            <div class="calendar__week">Mon</div>
            <div class="calendar__week">Tue</div>
            <div class="calendar__week">Wen</div>
            <div class="calendar__week">Thu</div>
            <div class="calendar__week">Fri</div>
            <div class="calendar__week">Sat</div>
            <div class="calendar__week">Sun</div>
            <div class="calendar__week">Mon</div>
            <div class="calendar__week">Tue</div>
            <div class="calendar__week">Wen</div>
            <div class="calendar__week">Thu</div>
            <div class="calendar__week">Fri</div>
            <div class="calendar__week">Sat</div>
            <div class="calendar__week">Sun</div>
            <div class="calendar__week">Mon</div>
            <div class="calendar__week">Tue</div>
            <div class="calendar__week">Wen</div>
            <div class="calendar__week">Thu</div>
            <div class="calendar__week">Fri</div>
            <div class="calendar__week">Sat</div>
            <div class="calendar__week">Sun</div>
            <div class="calendar__week">Mon</div>
            <div class="calendar__week">Tue</div>
            <div class="calendar__week">Wen</div>
            <div class="calendar__week">Thu</div>
            <div class="calendar__week">Fri</div>
            <div class="calendar__week">Sat</div>
        </div>

        <div class="calendar">
            <div
                class="calendar__row"
                v-for="(month, monthIndex) in fullCalendar"
                :key="monthIndex"
            >
                <div class="calendar__month">{{ monthIndex + 1 }}</div>
                <div
                    v-for="(day, index) in month"
                    :key="index"
                    :class="['calendar__day', day?.dayClass ?? '']"
                >
                    <a href="javascript:void(0)">
                        {{ day?.day }}
                    </a>
                </div>
            </div>
        </div>



    </div>
</template>

<script>

import {mapState} from "pinia";
import {useClientStore} from "../../stores/ClientStore";
import ModalHandler from "../../mixins/ModalHandler";
import EventsService from "../../services/EventsService";
import moment from "moment/moment";
import EventModal from "../Common/EventModal.vue";

export default {
    name: 'ArtistAvailabilityForClient',
    components: {EventModal},
    mixins: [ModalHandler],
    computed: {
        ...mapState(useClientStore, {
            artistId: 'artistId'
        }),
        fullCalendar() {
            return this.generateCalendar(this.year);
        },
    },
    mounted() {
        this.fetchEventsType()
    },
    methods: {
        async fetchEventsType() {
            try {
                const {data: response} = await EventsService.fetchEventsType()
                this.eventsType = response
            } catch {

            }
        },
        getDaysInMonth(month, year) {
            return new Date(year, month + 1, 0).getDate();
        },
        generateCalendar(year) {
            const calendar = [];
            for (let month = 0; month < 12; month++) {
                const daysInMonth = this.getDaysInMonth(month, year);
                const monthData = [];
                const firstDayOfWeek = new Date(year, month, 1).getDay();

                for (let i = 0; i < firstDayOfWeek; i++) {
                    monthData.push(null);
                }
                for (let day = 1; day <= daysInMonth; day++) {
                    const date = new Date(year, month, day);
                    const formattedDate = moment(date).format("YYYY-MM-DD");

                    let dayClass = this.events.hasOwnProperty(formattedDate) && this.events[formattedDate].length > 0
                        ? this.getDayClass(this.events[formattedDate][0].type)
                        : '';
                    let event = this.events.hasOwnProperty(formattedDate) && this.events[formattedDate].length > 0
                        ? this.events[formattedDate][0]
                        : null
                    let showDetails = this.events.hasOwnProperty(formattedDate) && this.events[formattedDate].length > 0
                        ? this.events[formattedDate][0].type !== 'Available'
                        : false;

                    const weekday = date.getDay();
                    monthData.push({
                        month,
                        date,
                        day,
                        weekday,
                        dayClass,
                        event,
                        showDetails
                    });
                }

                calendar.push(monthData);
            }
            return calendar;
        },
        getDisabledDates() {
            this.disabledDates = Object.entries(this.events)
                .filter(([date, eventsArray]) =>
                    eventsArray.length > 0 && eventsArray[0].type !== "Available"
                )
                .map(([date]) => date);
        },
        getDayClass(type) {
            switch (type) {
                case 'Booked':
                    return 'day-booked';
                case 'Available':
                    return 'day-available';
                case 'Hold':
                    return 'day-hold';
                case 'Blackout Day':
                    return 'day-blackout';
                case 'Travel Day':
                    return 'day-travel';
                default:
                    return '';
            }
        },
        async getEventsList() {
            try {
                const {data: response} = await EventsService.fetchEvents(this.artistId, this.year)
                this.events = response
                this.getDisabledDates()
            } catch (e) {
                this.$showErrorMessage()
            }
        }
    },
    data() {
        return {
            year: 2025,
            eventsType: [],
            events: [],
            disabledDates: [],
            selectedDay: null,
        }
    },
    watch: {
        artistId: {
            immediate: true,
            handler(newArtistId) {
                if (newArtistId) {
                    this.getEventsList();
                }
            },
        },
    },
}

</script>



<style scoped>

</style>
